<script>
    import Icon from '../icons/Icon.svelte';
    import { NICHE_TEMPLATES } from '../../data/nicheTemplates.js';

    export let isOpen = false;
    export let name = '';
    export let email = '';
    export let password = '';
    export let slug = '';
    export let phone = '';
    export let monthlyPrice = '97.00';
    export let businessProfile = 'hamburgueria';
    export let isCreating = false;
    export let createError = '';
    export let onSubmit = () => {};
    export let onClose = () => {};

    function handleNameInput(e) {
        name = e.target.value;
        // Gera slug automaticamente se o usuário não customizou manualmente
        if (!slug || slug === generateSlug(name.slice(0, -1))) {
            slug = generateSlug(name);
        }
    }

    function generateSlug(text) {
        return (text || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }
</script>

{#if isOpen}
    <div class="modal-overlay" on:click|self={onClose}>
        <div class="modal-card">
            <header class="modal-header">
                <div class="header-info">
                    <span class="modal-badge">NOVO CLIENTE SAAS</span>
                    <h3>Cadastrar Estabelecimento</h3>
                    <p>O restaurante será ativado imediatamente e receberá credenciais de acesso.</p>
                </div>
                <button type="button" class="btn-close" on:click={onClose}>
                    <Icon name="x" size={16} />
                </button>
            </header>

            <form on:submit|preventDefault={onSubmit} class="modal-form">
                {#if createError}
                    <div class="error-banner">
                        <Icon name="alert-triangle" size={14} />
                        <span>{createError}</span>
                    </div>
                {/if}

                <div class="form-grid">
                    <!-- Nome do Restaurante -->
                    <div class="form-group full-width">
                        <label for="create-name">Nome do Restaurante *</label>
                        <input
                            id="create-name"
                            type="text"
                            value={name}
                            on:input={handleNameInput}
                            placeholder="Ex: Pizzaria Bella Massa"
                            class="form-input"
                            required
                        />
                    </div>

                    <!-- Ramo Gastronômico Inicial -->
                    <div class="form-group full-width">
                        <label for="create-niche">Ramo do Estabelecimento (Preset Inicial)</label>
                        <div class="niche-select-grid">
                            {#each NICHE_TEMPLATES as niche}
                                <button
                                    type="button"
                                    class="niche-opt-btn {businessProfile === niche.id ? 'active' : ''}"
                                    on:click={() => businessProfile = niche.id}
                                >
                                    <Icon name={niche.svgIcon || 'utensils'} size={14} />
                                    <span>{niche.name}</span>
                                </button>
                            {/each}
                        </div>
                    </div>

                    <!-- Slug / Link -->
                    <div class="form-group full-width">
                        <label for="create-slug">Link Público do Cardápio (/cardapio/link)</label>
                        <div class="slug-input-wrapper">
                            <span class="slug-prefix">.../cardapio/</span>
                            <input
                                id="create-slug"
                                type="text"
                                bind:value={slug}
                                placeholder="bella-massa"
                                class="form-input with-prefix"
                                required
                            />
                        </div>
                    </div>

                    <!-- E-mail de Acesso -->
                    <div class="form-group">
                        <label for="create-email">E-mail do Proprietário (Login) *</label>
                        <input
                            id="create-email"
                            type="email"
                            bind:value={email}
                            placeholder="contato@restaurante.com"
                            class="form-input"
                            required
                        />
                    </div>

                    <!-- Senha Inicial -->
                    <div class="form-group">
                        <label for="create-pwd">Senha Inicial de Acesso *</label>
                        <input
                            id="create-pwd"
                            type="text"
                            bind:value={password}
                            placeholder="Defina uma senha provisória"
                            class="form-input"
                            required
                        />
                    </div>

                    <!-- Telefone WhatsApp -->
                    <div class="form-group">
                        <label for="create-phone">Telefone / WhatsApp Comercial</label>
                        <input
                            id="create-phone"
                            type="text"
                            bind:value={phone}
                            placeholder="(00) 00000-0000"
                            class="form-input"
                        />
                    </div>

                    <!-- Valor da Mensalidade -->
                    <div class="form-group">
                        <label for="create-price">Mensalidade SaaS Contratada (R$)</label>
                        <div class="prefix-input-box">
                            <span class="prefix">R$</span>
                            <input
                                id="create-price"
                                type="number"
                                step="1.00"
                                bind:value={monthlyPrice}
                                placeholder="97.00"
                                class="form-input with-curr"
                            />
                        </div>
                    </div>
                </div>

                <footer class="modal-footer">
                    <button type="button" class="btn-cancel" on:click={onClose}>
                        Cancelar
                    </button>
                    <button type="submit" class="btn-submit" disabled={isCreating}>
                        {#if isCreating}
                            <span class="spinner"></span>
                            <span>Criando restaurante...</span>
                        {:else}
                            <Icon name="check" size={14} />
                            <span>Cadastrar Restaurante</span>
                        {/if}
                    </button>
                </footer>
            </form>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 16px;
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
    }

    .modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 20px 24px;
        border-bottom: 1px solid #E2E8F0;
    }

    .modal-badge {
        font-size: 11px;
        font-weight: 800;
        color: #FF6A00;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        background: rgba(255, 106, 0, 0.08);
        border: 1px solid rgba(255, 106, 0, 0.2);
        padding: 3px 8px;
        border-radius: 6px;
        display: inline-block;
        margin-bottom: 6px;
    }

    .modal-header h3 {
        font-size: 18px;
        font-weight: 800;
        color: #0F172A;
        margin: 0 0 4px 0;
        letter-spacing: -0.3px;
    }

    .modal-header p {
        font-size: 13px;
        color: #64748B;
        margin: 0;
    }

    .btn-close {
        background: none;
        border: none;
        color: #94A3B8;
        cursor: pointer;
        padding: 6px;
        border-radius: 6px;
        display: flex;
    }

    .btn-close:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .modal-form {
        padding: 20px 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .error-banner {
        background: #FEE2E2;
        border: 1px solid #FECACA;
        color: #991B1B;
        padding: 10px 14px;
        border-radius: 8px;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 14px;
    }

    .full-width {
        grid-column: 1 / -1;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }

    .form-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 9px 12px;
        color: #0F172A;
        font-size: 13px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
        transition: border-color 0.2s, box-shadow 0.2s;
    }

    .form-input:focus {
        outline: none;
        border-color: #FF6A00;
        box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
    }

    .niche-select-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 8px;
    }

    .niche-opt-btn {
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        color: #475569;
        padding: 8px 10px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.15s ease;
    }

    .niche-opt-btn:hover {
        background: #F1F5F9;
        color: #0F172A;
        border-color: #CBD5E1;
    }

    .niche-opt-btn.active {
        border-color: #FF6A00;
        background: #FFF7ED;
        color: #FF6A00;
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.1);
    }

    .slug-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
    }

    .slug-prefix {
        position: absolute;
        left: 10px;
        font-family: monospace;
        font-size: 12px;
        color: #94A3B8;
        pointer-events: none;
    }

    .form-input.with-prefix {
        padding-left: 95px;
        width: 100%;
        font-family: monospace;
    }

    .prefix-input-box {
        position: relative;
        display: flex;
        align-items: center;
    }

    .prefix {
        position: absolute;
        left: 10px;
        font-size: 13px;
        color: #64748B;
        font-weight: 600;
        pointer-events: none;
    }

    .form-input.with-curr {
        padding-left: 34px;
        width: 100%;
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        padding-top: 14px;
        border-top: 1px solid #E2E8F0;
    }

    .btn-cancel {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-cancel:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .btn-submit {
        background: #FF6A00;
        border: 1px solid #EA580C;
        color: #FFFFFF;
        padding: 8px 20px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.2);
        transition: all 0.15s ease;
    }

    .btn-submit:hover:not(:disabled) {
        background: #EA580C;
        box-shadow: 0 3px 8px rgba(255, 106, 0, 0.3);
    }

    .btn-submit:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .spinner {
        width: 14px;
        height: 14px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }
</style>
